import PushNotifications from "./PushNotifications";

export default {
    init() {
        $(document).on("click", "[data-modal]", function (event) {
            event.preventDefault();
            const trigger = $(this);
            const modal = $(trigger.data("modal"));
            const title = trigger.data("modal-title");
            if (title) modal.find("[data-modal_title]").html(title);

            modal.modal("show");
            modal
                .find(".modal-body")
                .html(
                    '<div class="d-flex justify-content-center align-items-center p-3"><div class="spinner-border" role="status"><span class="visually-hidden">Loading...</span></div></div>',
                )
                .load(trigger.attr("href"), function () {
                    PushNotifications.markButton();
                });
        });
    },
};
